// extracted by mini-css-extract-plugin
export var active = "_bz-7";
export var container = "_bz-0";
export var evenWidth = "_bz-4";
export var large = "_bz-5";
export var outlet = "_bz-8";
export var slide = "_bz-2";
export var small = "_bz-6";
export var tab = "_bz-3";
export var tabs = "_bz-1";